module.exports = __webpack_public_path__ + "static/fonts/aeonik-black.0e746a6c.woff2";